import { NoticeEmails } from 'components/system/redirect/NoticeEmail/constants'
import { createExceptionServerPath } from 'components/system/redirect/NoticeEmail/function'

export const isEmailPath = (path: string) =>
  path.startsWith(createExceptionServerPath(NoticeEmails.ActivateVip)) ||
  path.startsWith(createExceptionServerPath(NoticeEmails.ConfirmEmail)) ||
  path.startsWith(createExceptionServerPath(NoticeEmails.RestoreProfile)) ||
  path.startsWith(createExceptionServerPath(NoticeEmails.PasswordRecovery))
